import { createBigDecimal } from '@0xtorch/big-decimal'
import { z } from 'zod'

const depositSchema = z.object({
  /** Coin */
  coin: z.string(),
  /** Chain */
  chain: z.string(),
  /** Amount */
  amount: z
    .string()
    .regex(/^\d+(\.\d+)?$/)
    .transform((v) => createBigDecimal(v)),
  /** Transaction ID */
  txID: z.string(),
  /** Deposit status */
  status: z.union([
    /** unknown */
    z.literal(0),
    /** toBeConfirmed */
    z.literal(1),
    /** processing */
    z.literal(2),
    /** success (finalised status of a success deposit) */
    z.literal(3),
    /** deposit failed */
    z.literal(4),
    /** pending to be credited to funding pool */
    z.literal(10011),
    /** Credited to funding pool successfully */
    z.literal(10012),
  ]),
  /** Deposit target address */
  toAddress: z.string(),
  /** Tag of deposit target address */
  tag: z.string().nullable(),
  /** Deposit fee */
  depositFee: z.union([
    z.literal('').transform(() => createBigDecimal('0')),
    z
      .string()
      .regex(/^\d+(\.\d+)?$/)
      .transform((v) => createBigDecimal(v)),
  ]),
  /** Last updated time */
  successAt: z
    .string()
    .regex(/^\d+$/)
    .transform((v) => Number.parseInt(v, 10)),
})

export type Deposit = z.infer<typeof depositSchema>

export const depositResultSchema = z.object({
  rows: z.array(depositSchema),
  nextPageCursor: z.string().nullable(),
})
